/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Fact_Ribbon_LInputs */

const en_wc_fact_ribbon_l = /** @type {(inputs: Wc_Fact_Ribbon_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Of Word's ribbon features already covered.`)
};

/**
* | output |
* | --- |
* | "Of Word's ribbon features already covered." |
*
* @param {Wc_Fact_Ribbon_LInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_fact_ribbon_l = /** @type {((inputs?: Wc_Fact_Ribbon_LInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Fact_Ribbon_LInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_fact_ribbon_l(inputs)
});
export { wc_fact_ribbon_l as "wc.fact.ribbon_l" }